"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _material = require("@mui/material");

var _Icon = require("../Icon");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["color", "icon", "label", "indented", "noWrap"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledMuiMenuItem = (0, _material.styled)(_material.MenuItem, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "indented";
  }
})(function (_ref) {
  var theme = _ref.theme,
      _ref$indented = _ref.indented,
      indented = _ref$indented === void 0 ? false : _ref$indented;
  return {
    paddingLeft: indented ? theme.spacing(4) : undefined
  };
});
var StyledSpan = (0, _material.styled)("span")(function () {
  return {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});
var MenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var color = _ref2.color,
      icon = _ref2.icon,
      label = _ref2.label,
      _ref2$indented = _ref2.indented,
      indented = _ref2$indented === void 0 ? false : _ref2$indented,
      _ref2$noWrap = _ref2.noWrap,
      noWrap = _ref2$noWrap === void 0 ? false : _ref2$noWrap,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledMuiMenuItem, _objectSpread(_objectSpread({}, rest), {}, {
    indented: indented,
    ref: ref,
    children: [(icon || color) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      color: color,
      iconName: icon || "square",
      mr: 2
    }), noWrap ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpan, {
      children: label
    }) : label]
  }));
});
var _default = MenuItem;
exports.default = _default;